// Para cada state, nós teremos o mutation-types

// Diferenciando pelo prefixo AUTH, caso tivesse outro SET_USER
export const SET_SERIES = 'SERIES/SET_SERIES'